import { snakeCase } from 'lodash';
import React, { ReactNode, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FinancialsTooltipKeys,
  ProjectFinancialsContractType,
} from 'api/project';

interface Props {
  financialContractType: ProjectFinancialsContractType;
}

interface ReturnProps {
  getTooltipContent: (
    keys: FinancialsTooltipKeys[],
    showExtraInfo?: boolean,
  ) => ReactNode;
}

export const useFinancialsTooltips = ({
  financialContractType,
}: Props): ReturnProps => {
  const getTooltipContent = useCallback(
    (keys: FinancialsTooltipKeys[], showEstimates = false): ReactNode => (
      <>
        {showEstimates && (
          <>
            <FormattedMessage
              id={`project.financials.${financialContractType}.estimated.info`}
              values={{ i: (chunks) => <i>{chunks}</i> }}
            />
            <br />
            <FormattedMessage
              id={`project.financials.${financialContractType}.actual.info`}
              values={{ i: (chunks) => <i>{chunks}</i> }}
            />
            <br />
            <FormattedMessage
              id={`project.financials.${financialContractType}.separator`}
            />
            <br />
            <br />
          </>
        )}
        {keys.map((key, index) => (
          <>
            {showEstimates && (
              <>
                <FormattedMessage
                  id={`project.financials.${financialContractType}.estimated_${snakeCase(
                    key,
                  )}.formula`}
                  values={{ b: (chunks) => <b>{chunks}</b> }}
                />
                <br />
              </>
            )}
            <FormattedMessage
              id={`project.financials.${financialContractType}.${snakeCase(
                key,
              )}.formula`}
              values={{ b: (chunks) => <b>{chunks}</b> }}
            />

            {index < keys.length - 1 && (
              <>
                <br />
                <br />
              </>
            )}
          </>
        ))}
      </>
    ),
    [financialContractType],
  );

  return {
    getTooltipContent,
  };
};
